export default {
  NEIGHBOURHOOD_CREDIT: 'NeighbourhoodCredit',
  CREDIT_PLUS: 'CreditPlus',
  EQUIFAX: 'Equifax',
  EQUIFAX_ID_AUTH_NEIGHBOURHOOD_CREDIT: 'EquifaxIDAuthNeighbourhoodCredit',
};
